import axios from 'axios'
import router from '../../router'

/**
 * initial state
 */
const state = () => ({
  // todo
})

/**
 * getters
 */
const getters = {
  // todo
}

/**
 * mutations
 */
const mutations = {
  // todo
}

/**
 * actions
 */
const actions = {
  /**
   * List Quotation
   */
  /**
   * List Quotation
   */
  HistoryList(context, credentials) {
    return new Promise((resolve, reject) => {
      console.log('API list quotation params ::', credentials)
      axios
        .post(`${process.env.VUE_APP_HOME_TAMJAI_MAIN}/history_view`, credentials)
        .then((response) => resolve(response.data.data))
        .catch((error) => reject(error))
    })
  },

  /**
   * View Quotation Detail
   * @param paTamjaiId
   * @return {array}
   */
  viewQuotationDetail(context, credentials) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${process.env.VUE_APP_HOME_TAMJAI_MAIN}/detail/${credentials.hashId}`)
        .then((response) => {
          console.log('API view quotation detail ::', response)
          if (response.status == 200) {
            if (response.data.isSuccess) {
              if (response.data.data.id == null) {
                resolve('No content')
                console.error('No content')
                router.push({ name: 'history' })
              }
              resolve(response.data.data)
            } else {
              reject(response.data.message)
            }
          } else reject(response.data)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },

  uploadJuristicImages(context, credentials) {
    return new Promise((resolve, reject) => {
      console.log('API upload juristic image params ::', credentials)
      axios
        .post(`${process.env.VUE_APP_HOME_TAMJAI_MAIN}/upload_juristic_images`, credentials)
        .then((response) => resolve(response.data.data))
        .catch((error) => reject(error))
    })
  },

  uploadAssetImages(context, credentials) {
    return new Promise((resolve, reject) => {
      console.log('API upload asset image params ::', credentials)
      axios
        .post(`${process.env.VUE_APP_HOME_TAMJAI_MAIN}/upload_asset_images`, credentials)
        .then((response) => resolve(response.data.data))
        .catch((error) => reject(error))
    })
  },

  approveImage(context, credentials) {
    return new Promise((resolve, reject) => {
      console.log('API approve image params ::', credentials)
      axios
        .post(`${process.env.VUE_APP_HOME_TAMJAI_MAIN}/approve_photo`, credentials)
        .then((response) => resolve(response.data.data))
        .catch((error) => reject(error))
    })
  },

  updatedPaymentDateTamjai(context, credential) {
    return new Promise((resolve, reject) => {
      const param = {
        type: credential.type,
        amount: credential.amount,
        payment_type: credential.payment_type,
        payment_date: credential.payment_date,
      }
      console.log('API update payment PA Tamjai ::', param)
      axios
        .post(process.env.VUE_APP_UPDATE_PAYMENT_DATE_HOME_TAMJAI + '/' + credential.id, param)
        .then((res) => resolve(res))
        .catch((err) => reject(err))
    })
  },

  reportCiaStatus2(context, credential) {
    return new Promise((resolve, reject) => {
      const params = {
        startDate: credential.startDate,
        endDate: credential.endDate,
        referral_type: credential.referral_type,
      }

      axios
        .post(process.env.VUE_APP_REPORT_CIA_STATUS_2_HOME_TAMJAI, params, {
          responseType: 'blob',
        })
        .then((res) => resolve(res))
        .catch((err) => reject(err))
    })
  },

  async imageUrlToBase64(context, credentials) {
    const response = await axios.get(credentials.url, { responseType: 'blob' })

    const base64 = await new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () => resolve(reader.result)
      reader.onerror = reject
      reader.readAsDataURL(response.data)
    })

    const match = base64.match(/^data:image\/(\w+);base64,(.+)$/)
    if (!match) return base64
    else return match[2]
  },

  uploadSubsinSellerStatus(context, credentials) {
    return new Promise((resolve, reject) => {
      console.log('API upload subsin seller status params ::', credentials)
      let formData = new FormData()
      formData.append('file', credentials.file)

      axios
        .post(`${process.env.VUE_APP_USER_STAFF_UPLOAD_SUBSIN_SELLER_STATUS}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  },

  updateSubsinSellerStatus(context, credentials) {
    return new Promise((resolve, reject) => {
      console.log('API update subsin seller status params ::', credentials)
      axios
        .post(`${process.env.VUE_APP_USER_STAFF_SUBSIN_SELLER_STATUS}/${credentials.staffId}`, {
          subsin_seller_status: true,
        })
        .then((response) => resolve(response.data.data))
        .catch((error) => reject(error))
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
